import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { StateService } from '../../../state.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-ifair-qa',
  templateUrl: './app-ifair-qa.component.html',
  styleUrls: ['./app-ifair-qa.component.scss']
})

export class AppIfairQAComponent implements OnInit {
  @ViewChild('content') content: ElementRef;
  @ViewChild('contentMobile') contentMobile : TemplateRef<any>
  @ViewChild('contentDesktop') contentDesktop : TemplateRef<any>
  
  public isQA: Params;

  apps: any;
  appsOld: any;
  routeVersions = 'http://vivo-dev-node.focustextil.loc.br:1037/api/v2/versions';
  sistemasQA = [];
  
  constructor(
    private cookie: CookieService,
    private stateService: StateService,
    private modal: NgbModal,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) {
    setInterval(() => {
      let portal = JSON.parse(this.cookie.get('portal') || '{}');
      
      if (portal.User) { // se o usuário está logado
        this.sistemasQA = portal.User.Sistemas;

        if( (/^(funcionario|admvendas|gestor)$/i).test(portal.User.Tipo) ){
          this.sistemasQA = []
          this.sistemasQA = ['iFair']
        };
      };
      this.appsOld = JSON.parse(localStorage.getItem('appstore-notifications') || '{}');
    }, 100);
  }

  parentToggleClass($event){
    let element = $event.target;
    if(element.getAttribute('toggle') !== null){
      let parent = element.parentElement;
      parent.classList.toggle('active');
    };
  }


  sanitize(url: string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  openModalMobile (): void {
    this.modalService.open(this.contentMobile);
  }

  closeModalMobile (): void {
    this.modalService.dismissAll(this.contentMobile)
  }

  openModalDesktop (): void {
    this.modalService.open(this.contentDesktop);
  }

  closeModalDesktop (): void {
    this.modalService.dismissAll(this.contentDesktop)
  }

  getMessage (apps: string[]): string {

    if(apps.includes('WebRep')) {
      return 'Antes de iniciar suas atualizações certifique-se de estar conectado a uma rede de internet. Clique nos botões ou aponte a câmera para o QR Code para abrir, atualizar ou baixar no seu celular ou tablet.'
    }

    return 'Aqui estarão somente as aplicações QA.'
  }

  getNamesApps (appName: string): string {
    switch (appName) {
      case 'iFair':
        return 'iFair - QA'
      default:
        return appName
    }
  }

  openModalInformations (event: Event): void {
    event.preventDefault()
  }

  ngOnInit() {
    let interval_ = setInterval( () => {
      this.apps = this.stateService.getGlobal('appstore');
      if( window.location.href.indexOf('/appstore') === -1 ){
        clearInterval(interval_);
      };
    }, 100);
  }
}